// Asset loading: GLB (meshopt-compressed when the manifest says so), textures, and the progress the boot screen shows.
// Everything is relative to the page (CrazyGames serves the build from its own CDN — relative paths only).

import * as THREE from "three";
import { GLTFLoader, type GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";
import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module.js";

const loader = new GLTFLoader();
loader.setMeshoptDecoder(MeshoptDecoder);
const texLoader = new THREE.TextureLoader();

const cache = new Map<string, Promise<GLTF>>();
let done = 0, total = 0;
const progress: ((f: number) => void)[] = [];
export const onProgress = (f: (frac: number) => void) => { progress.push(f); };
function tick() { done++; for (const f of progress) f(total ? done / total : 1); }

/** load a GLB once; later calls share the promise (clone what you place) */
export function glb(url: string): Promise<GLTF> {
  let p = cache.get(url);
  if (!p) {
    total++;
    p = loader.loadAsync(url).then((g) => { tick(); return g; }, (e) => { tick(); throw new Error(`load ${url}: ${e?.message || e}`); });
    cache.set(url, p);
  }
  return p;
}
export function texture(url: string): Promise<THREE.Texture> {
  total++;
  return texLoader.loadAsync(url).then((t) => { tick(); t.colorSpace = THREE.SRGBColorSpace; return t; });
}
export async function json<T = any>(url: string): Promise<T> { const r = await fetch(url); if (!r.ok) throw new Error(`${url} ${r.status}`); return r.json(); }

/** a missing optional asset must never stop the game: resolve null and log once */
export async function optional<T>(p: Promise<T>): Promise<T | null> { try { return await p; } catch (e) { console.warn("[assets]", (e as any)?.message || e); return null; } }
